import cn from 'classnames';

export const getClassName = ({ disabled, color, hoverColor, className }) =>
  cn(
    `tw-ui-dropdown-link whitespace-nowrap w-full text-left text-${color} ${
      disabled ? 'opacity-50 hover:bg-white' : `hover:text-${hoverColor}`
    }`,
    className
  );
